/* eslint-disable func-names */
$('[data-lazy-load-content]').each(function () {
  const contentId = $(this).data('lazy-load-content');

  $(this)
    .load(`${window.location.pathname}ajax.html?content=${contentId}`, function () {
      $(this).addClass('loaded');
    });
});
